<div class="header-image-top" id="displayLogo">
  <nav class="navbar navbar-expand-md navbar-light nav-top-header"><a class="navbar-brand abs" href=""><img
        src="../mw/assets/img/emirates-logo.png"></a>
    <ul class="navbar-nav mr-auto">
      <li class="nav-item active"><a class="nav-link" href=""><img
            src="../mw/assets/img/dubai-gov-logo.png"></a></li>
    </ul>
    <ul class="navbar-nav ml-auto">
      <li class="nav-item"><a class="nav-link" href=""><img class="dewalogo" src="../mw/assets/v2/img/dewa-logo.png"></a></li>
    </ul>
  </nav>
</div>
<!--new login design start-->
<div class="new-login clearfix" style="display:none">
    <div class="header-main">
      <div class="container-fluid">
        <div class="top-login-header">
          <div class="row">
            <div class="col s3 m4 maing"> <a class="gov-logo" href="#"> <img src="../../mw/assets/img/gov-dubai.png"
                  alt="government-of-dubai"> </a> </div>
            <div class="col s5 m4 center"> <a class="gov-logo center" href="#"> <img
                  src="../../mw/assets/img/emirates-logo.png" alt="government-of-dubai" style="float:none;"> </a> </div>
            <div class="col s4 m4"> <a class="dewa-logo-login" href="#"> <img class="dewalogo" src="../../mw/assets/img/dewa-logo-login.png"
                  alt="dewa-logo-login"> </a> </div>
          </div>
          <!-- Top Menu Items -->
        </div>
      </div>
    </div>
    <section class="middle-login" style="margin-top:45px">
      <div class="container-fluid login-area" id="main-logo-caption">
        <div class="row">
          <div class="col s12 m7 l7 center">
            <div class=" line-rht"><img src="../../mw/assets/img/dewa-login.jpg" class="responsive-img" alt="DEWA login" />
            </div>
          </div>
          <div class="col s12 m5 l5" style="display:none">
            <div class="container-login">
              <h5>isg is DEWA's Corporate Performance Management Platform.</h5>
              <div style="margin-top:25px"> </div>
              <form class="form-horizontal login-section" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                <div class="custon-login-material">
                  <div class="row">  
                    <div class="col s12">
                      <div class="custon-login-form clearfix b-b1">
                        <div class="input-field col s12">
                          <i class="material-icons dp48 small">account_circle</i>
                          <input id="inputEmail3" type="text" class="validate" placeholder="Username"
                            formControlName="username" [ngClass]="{ 'is-invalid': submitted && f.username.errors }">
                          <label for="inputEmail3">Username</label>
                          <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                            <div *ngIf="f.username.errors.required" class="error-login" style="color:coral;">Username is
                              required</div>
                          </div>
                        </div>
                      </div>
                      <div class="custon-login-form clearfix b-b1">
                        <div class="input-field col s12">
                          <i class="material-icons dp48 small">lock_outline</i>
                          <input id="inputPassword3" type="password" class="validate" placeholder="*******"
                            formControlName="password" [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
                          <label for="inputPassword3">Password</label>
                          <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                            <div *ngIf="f.password.errors.required" class="error-login" style="color:coral;">Password is
                              required</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row last">
                  <div *ngIf="invalid" style="color:coral;text-align:center;">Invalid User<br /></div>
                  <div class="col s12">
                    <button class="btn waves-effect waves-light green darken-4 btn-mush btm-submit-login" type="submit"
                      name="action"><i class="fa fa-sign-in"></i>Login</button>
                  </div>
                </div>
                <div class="col s6">
                  <p>                   
                  </p>
                </div>
                <div class="col s6 lost-password"> </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--footer class="container-fluid">
      <div class="footer-end">
        <div class="right-align">&copy; 2020 Dubai Electricity and Water Authority. All Rights Reserved. | Version 5.2.7
        </div>
      </div>
    </footer-->
  </div>
  <!--new login design end-->
  <style>
    body {
      background: #fff !important;
    }
    .nav-sm .container.body .right_col,
    .nav-md .container.body .right_col {
      padding: 0 !important;
      margin-left: 0;
      z-index: 2;
    }
  </style>
  <div class="clearfix"></div>
  <div class="limiter" id="login-area">
    <div class="container-login100">
      <div class="wrap-login100">
        <form class="login100-form validate-form" style="background-image: url('../../../mw/assets/v2/img/bg-01.jpg');"
          [formGroup]="loginForm">
          <div class="row m-0 bg-login-inner">
            <div class="col-lg-12 p-0">  
              <span class="login100-form-title p-b-43">
                Login
              </span>
              <div class="form-group" style="display:none">
                <label for="email">Username</label>
                <input type="text" id="inputEmail31" class="form-control validate" placeholder="Username"
                  formControlName="username" [ngClass]="{ 'is-invalid': submitted && f.username.errors }">
                <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                  <div *ngIf="f.username.errors.required" class="error-login" style="color:coral;">Username is required
                  </div>
                </div>
              </div>  
              <div class="form-group" style="display:none">
                <label for="pwd">Password:</label>
                <input type="password" id="inputPassword31" class="form-control validate" placeholder="*******"
                  formControlName="password" [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
                <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                  <div *ngIf="f.password.errors.required" class="error-login" style="color:coral;">Password is required
                  </div>
                </div>
              </div>  
              <button type="submit" class="btn btn-mt-green btn-block mt-3" (click)="Authorize()">Login</button>  
            </div>
          </div>
        </form>
        <div class="login100-more">
          <img class="oneId-logo" src="../../mw/assets/img/OneID_logo.png"/>
          <h6>Welcome to</h6>
          <h4>OneID Portal</h4>
          <p>This is a one stop place from where you can access all DEWA internal and external portals from a single secure login. Just login with your DEWA credentials and enjoy easy access to all related portals.</p>
          <div class="footer" style="padding-top:30px">
            <div class="footer-message">Any Questions?</div>
            <div class="footer-mail">drop us an email at iam@dewa.gov.ae</div>
          </div>
        </div>
         
      </div>
    </div>
  </div>  
  <!--footer>
    <div class="row">
      <div class="col-auto">
        <p class="pull-left">
          &copy; 2021 Dubai Electricity & Password. All Rights Reserved.
        </p>
      </div>
      <div class="col">
        <p class="pull-right">
          v1.0
        </p>
      </div>
    </div>
    <div class="clearfix"></div>
  </footer-->  